@let followedProducers = followedProducers$ | async;
@let followedProducersEvents = followedProducersEvents$ | async;

<app-layout [isProducerArea]="true">
  <ng-container>
    <app-page-header
      [title]="'Produtores seguidos'"
      [titleIcon]="'pi pi-users'"
      [subtitle]="'Visualize os eventos e gerencie os produtores que você segue.'"
      [breadcrumbs]="[
        { label: 'Início', link: '/', icon: 'pi pi-home' },
        { label: 'Produtores seguidos', icon: 'pi pi-users' },
      ]">
    </app-page-header>
    <div class="page-container">
      <app-followed-producers [followedProducers]="followedProducers" />
      <app-followed-producers-events [events]="followedProducersEvents" />
    </div>
  </ng-container>
</app-layout>
